module.exports = __webpack_public_path__ + "img/logo-rtl-dark.c7f3d73c.svg";